import createIcon from '../../createIcon';

/**
 * @component @name MobiledataOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNzEwMSA2LjI4OTYxSDE5LjcxMDFMMTUuNzEwMSAyLjI4OTYxTDExLjcxMDEgNi4yODk2MUgxNC43MTAxVjEwLjQ1OTZMMTYuNzEwMSAxMi40NTk2VjYuMjg5NjFaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMy41MjAxIDIuMDk5NjFMMi4xMDAxIDMuNTA5NjFMOC43MTAxIDEwLjExOTZWMTYuMjk5Nkw1LjcxMDEgMTYuMzA5Nkw5LjcxMDEgMjAuMjg5NkwxMy43MTAxIDE2LjI4OTZMMTAuNzEwMSAxNi4yOTk2VjEyLjExOTZMMjAuNDkwMSAyMS44OTk2TDIxLjkwMDEgMjAuNDc5NkwzLjUyMDEgMi4wOTk2MVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MobiledataOff = createIcon('MobiledataOff', [
  [
    'path',
    {
      d: 'M16.7101 6.28961H19.7101L15.7101 2.28961L11.7101 6.28961H14.7101V10.4596L16.7101 12.4596V6.28961Z',
      key: '17p8x3',
    },
  ],
  [
    'path',
    {
      d: 'M3.5201 2.09961L2.1001 3.50961L8.7101 10.1196V16.2996L5.7101 16.3096L9.7101 20.2896L13.7101 16.2896L10.7101 16.2996V12.1196L20.4901 21.8996L21.9001 20.4796L3.5201 2.09961Z',
      key: 'jyxq0v',
    },
  ],
]);

export default MobiledataOff;
